import { render, staticRenderFns } from "./MaterialOrgList.vue?vue&type=template&id=f95b6d50"
import script from "./MaterialOrgList.vue?vue&type=script&lang=ts"
export * from "./MaterialOrgList.vue?vue&type=script&lang=ts"
import style0 from "./MaterialOrgList.vue?vue&type=style&index=0&id=f95b6d50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports